import React, {useEffect, useState} from 'react';
import {Button, Flex} from 'antd';
import {SquareHalf} from '@phosphor-icons/react';
import {Scrollbars} from 'react-custom-scrollbars-2';
import {useViewerStore} from "../../../../../store/store";
import {Toggle} from '../../../../index';
import { TabItem } from '../../../../../@types/types';

interface TabProps {
    items: Array<TabItem>;
    isMultiMenu?: boolean;
}

const Tab = (props: TabProps) => {

    const {sceneViewer, pathname, isRightSidebarOpen, isStreetViewVisible, 
        isTabandHoldUp, isTreeLabelVisible, isTreeHeightLabelVisible} = useViewerStore();

    const [items, setItems] = useState(props.items);
    const [isMainTabShow, setIsMainTabShow] = useState(props.isMultiMenu ? false : true)

    useEffect(() => {
        setItems(props.items);
    }, [props.items]);

    useEffect(() => {
        // If multi menu and main tab is shown, hide it
        if (props.isMultiMenu && isMainTabShow) {
            setIsMainTabShow(false);
        }

        const shouldShowTreeLabel = pathname.includes("price-calculation") || pathname.includes("tree-cart");

        // Disable tree height label if switching tabs
        if (isTreeHeightLabelVisible) {
            useViewerStore.setState({ isTreeHeightLabelVisible: false });
            sceneViewer?.toggleTreeLabel();
        }

        // Sync tree label visibility with pathname
        if (isTreeLabelVisible !== shouldShowTreeLabel) {
            useViewerStore.setState({ isTreeLabelVisible: shouldShowTreeLabel });
            sceneViewer?.toggleTreeLabel();
        }
    }, [pathname]);

    const show = (item: TabItem, index: number) => {
        const updatedItems = items.map((tab, idx) => ({ ...tab, is_active: idx === index}));
        setItems(updatedItems);
        item.onActiveCallback?.();
        document.body.classList.add('toolbar-open');
        document.getElementById('tabPoint')?.classList.remove('floating');
        if (sceneViewer && item.title) sceneViewer.setTabInfo(item.title);
    };

    const toggleMainTab = () => setIsMainTabShow(prev => !prev);

    useEffect(() => {
        const canvasContainer = document.getElementById('canvasContainer') as HTMLElement | null;
        if (!canvasContainer || isStreetViewVisible) return;

        const bc = document.body.classList; // Body classList
        const cc = canvasContainer.classList; // Canvas container classList

        // Reset all classes first
        bc.remove('multi-toolbar-open-toggle', 'multi-toolbar-open', 'toolbar-open');
        cc.remove('canvas-collapsed-multimenu-maintab', 'canvas-collapsed-multimenu', 'canvas-collapsed', 'canvas-expanded');

        if (isRightSidebarOpen) {
            bc.add('toolbar-open');
            if (props.isMultiMenu) {
                if (isMainTabShow) {
                    cc.add('canvas-collapsed-multimenu-maintab');
                    bc.add('multi-toolbar-open-toggle');
                } else {
                    cc.add('canvas-collapsed-multimenu');
                    bc.add('multi-toolbar-open');
                }
            } else {
                cc.add('canvas-collapsed');
            }
            canvasContainer.setAttribute('data-collapsed', 'true');
        } else {
            cc.add('canvas-expanded');
            canvasContainer.setAttribute('data-collapsed', 'false');
        }

        setTimeout(() => {
            sceneViewer?.resizeCanvas();
        }, 500);

    }, [isRightSidebarOpen, isStreetViewVisible, isMainTabShow]);

    useEffect(() => {
        useViewerStore.setState({isRightSidebarOpen: !isTabandHoldUp});
    }, [isTabandHoldUp])

    // useEffect(() => {
    //     const handleTablet = () => {
    //         if (window.innerWidth < 1025) {
    //             useViewerStore.setState({isRightSidebarOpen: false});
    //         } else if (window.innerWidth > 1024) {
    //             useViewerStore.setState({isRightSidebarOpen: true});
    //         }
    //     };
    //
    //     handleTablet();
    // }, [window.innerWidth]);


    return (
        <>
            <div
                className={`tabs ${isRightSidebarOpen ? isMainTabShow ? 'show' : "hide-multitab" : props.isMultiMenu ? "multi_hide" : 'hide'}`}
                id='tabPoint'>
                <Button
                    id={"closeSideToolbarTabBtn"}
                    type='default'
                    size='large'
                    icon={<SquareHalf size={26} weight='fill'/>}
                    onClick={() => useViewerStore.setState({isRightSidebarOpen: !isRightSidebarOpen})}
                />

                {props.isMultiMenu && (
                    <div className='tab__wrap multi_tab_wrap'>
                        <div className='tab__item multi_tab_item'>

                            <Flex
                                align="center"
                                justify="space-between"
                                className="small_input_flex"
                            >
                                <div>
                                    <span className="tab__input--label small_input_label_e ">
                                        View Buildings:
                                    </span>
                                </div>
                                <Toggle
                                    on={isMainTabShow}
                                    onChange={toggleMainTab}
                                    size="small"

                                />
                            </Flex>
                        </div>
                        {items.map((item, index) => (
                            <div key={index} className={`tab__content ${(item['is_active']) ? 'active' : ''}`}>
                                {item.is_active && (
                                    <Scrollbars style={{width: "100%", height: "100%"}} autoHide
                                                renderThumbHorizontal={props => <div {...props}
                                                                                     className="thumb-horizontal"/>}
                                                renderThumbVertical={props => <div {...props}
                                                                                   className="thumb-vertical"/>}>
                                        {item.secondcontent && item.secondcontent}
                                    </Scrollbars>
                                )}
                            </div>
                        ))}
                    </div>
                )}

                <div className='tab__wrap'>
                    <ul className='tab__list'>
                        {
                            items.map((item, index) => {
                                return (
                                    <li
                                        ref={item.ref}
                                        key={index + 'litab'}
                                        id={item.id ? item.id : "tabIcon"}
                                        title={item.title || ""}
                                        onClick={() => show(item, index)}
                                        className={`tab__item ${item.is_active ? 'active' : ''}`}
                                    >
                                        {item.icon}
                                    </li>
                                )
                            })
                        }
                    </ul>
                    {items.map((item, index) => (
                        <div key={index} className={`tab__content ${item.is_active ? 'active' : ''}`}>
                            {item.is_active && (
                                <Scrollbars
                                    style={{width: "100%", height: "100%"}}
                                    autoHide
                                    renderThumbHorizontal={props => <div {...props} className="thumb-horizontal"/>}
                                    renderThumbVertical={props => <div {...props} className="thumb-vertical"/>}>
                                    {item.content}
                                </Scrollbars>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}

export default Tab;